import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions/index';

class Logout extends Component {
  componentDidMount() {
    this.props.Logout();
  }

  render() {

    return <Redirect to='/' />
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    Logout: () => dispatch(actionTypes.logout())
  }
}

export default connect(null, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.jsx